export function QuoteSection() {
  return (
    <section className="py-20 px-6 bg-stone-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-light leading-relaxed mb-6">
          "Embody French elegance through exceptional productions and a bespoke visual signature"
        </h2>
      </div>
    </section>
  );
}
